import styled from 'styled-components';

const SearchAgainStyles = styled.div`
    .search-again-title {
        margin-top: 20px;
    }
    button {
        display: flex;
        margin: 5px auto 0;
        padding: 5px 10px;
    
        border: 1px solid #e1261c;
        border-radius: 4px;
        background: #e1261c;
        color: white;
        font-size: 13px;
        cursor: pointer;
    }
`;

export default SearchAgainStyles;